import { ValueOf } from './util';

export const approvalStatus = {
  WAITING: '承認待ち',
  /** 日時変更時での状態 */
  CHANGE_WAITING: '変更承認待ち',
  CANCEL_WAITING: '取消承認待ち',
  APPROVE: '承認済',
  REJECT: '却下',
  WITHDRAWAL: '申請取下げ',
  CANCEL: '',
  FAILURE: '',
} as const;

export type ApprovalStatusKey = keyof typeof approvalStatus;
export type ApprovalStatusValue = ValueOf<typeof approvalStatus>;

export const approvalStatusKeys = Object.keys(approvalStatus) as ApprovalStatusKey[];

/** v-select用items */
export const approvalStatusItems = approvalStatusKeys
  .filter((value) => value !== 'CANCEL' && value !== 'FAILURE')
  .map((key) => ({
    title: approvalStatus[key],
    value: key,
  }));
